import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import { agents as actionTypes } from '$constants/action-types';

const defaultState = Immutable({
  items: []
});

const reducer = {
  [actionTypes.FETCH_CURRENT_SUCCESS](state, action) {
    return state.set('current', action.result);
  }
}

reducer[actionTypes.UPDATE_SUCCESS] = reducer[actionTypes.FETCH_CURRENT_SUCCESS];

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/agents.js